import { api } from '@/core/api/'

const apiUrl = 'api/edenstudentvisualimpairments'

export default {
  getReportAvailableAcademicYears() {
    return api.get(`${apiUrl}/reportavailableacademicyears`)
  },
  getAvailableAcademicYears() {
    return api.get(`${apiUrl}/availableAcademicYears`)
  },
  createEstudentVisualImpairmentsReport(academicYearId) {
    return api.post(
      `${apiUrl}/createstudentvisualimpairmentsreport/${academicYearId}`
    )
  },
  getEdenStudentVisualImpairments(params) {
    return api.get(`${apiUrl}/edenstudentvisualimpairments`, { params: params })
  },
  questionAnswerValidate(academicYearId) {
    return api.get(`${apiUrl}/questionanswervalidate/${academicYearId}`)
  },
  submitReport(payload) {
    return api.post(`${apiUrl}/submitreport`, payload)
  },
  updateReport(id) {
    return api.put(`${apiUrl}/${id}/updatereport`)
  },
}
